const SELECTOR = 'img[data-media-image="progressive"]'

const hydrated = new WeakSet()

function reveal(image) {
  image.classList.remove('opacity-0')
}

function bind(image) {
  if (!image || hydrated.has(image)) return

  hydrated.add(image)

  if (image.complete && image.naturalWidth !== 0) {
    reveal(image)
    return
  }

  const handle = () => {
    reveal(image)
    image.removeEventListener('load', handle)
    image.removeEventListener('error', handle)
  }

  image.addEventListener('load', handle)
  image.addEventListener('error', handle)
}

export function hydrateMediaImages(root = document) {
  if (!root) return

  if (root instanceof HTMLImageElement) {
    bind(root)
    return
  }

  const images = root.querySelectorAll?.(SELECTOR) || []
  for (const image of images) {
    bind(image)
  }
}

const init = () => hydrateMediaImages(document)

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true })
} else {
  init()
}

document.addEventListener('ui:hydrate', (event) => {
  const target = event.detail?.target || event.target
  hydrateMediaImages(target)
})

document.addEventListener('shopify:section:load', (event) => {
  hydrateMediaImages(event.target)
})
